export const css = {
	root: 'KJIHoZ_q',
	' _key': 'ascm-theme/ascm/variants/ascmpreview'
};

export default css;
